import { DISTANCE_UNITS } from '../../constants/constants';
import { ICoordinates } from '../../interfaces/geo';

const earthRadiusInKm = 6371;
const earthRadiusInMiles = 3958;

function toRadians(n: number): number {
  // eslint-disable-next-line no-magic-numbers
  return (n * Math.PI) / 180;
}

// This is a Haversine formula https://en.wikipedia.org/wiki/Haversine_formula
export function getDistance(
  locationA: ICoordinates,
  locationB: ICoordinates,
  unit = DISTANCE_UNITS.KMS,
): number {
  const dLat = toRadians(locationB.latitude - locationA.latitude);
  const dLon = toRadians(locationB.longitude - locationA.longitude);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRadians(locationA.latitude)) *
      Math.cos(toRadians(locationB.latitude)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const earthRadus = unit === DISTANCE_UNITS.MILES ? earthRadiusInMiles : earthRadiusInKm;
  return earthRadus * c;
}
